import Flag, { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { inject, observer } from 'mobx-react';
import React from 'react';

import Store from '../store';
import FlagStore, { FlagType, InternalFlag } from '../store/flagStore';

interface Props {
  flagStore: FlagStore;
}

@observer
class Flags extends React.Component<Props> {
  render() {
    const flags = this.props.flagStore.flags.map((flagProps: InternalFlag) => {
      const FlagComponent = flagProps.shouldAutoDismiss ? AutoDismissFlag : Flag;
      return (
        <FlagComponent
          appearance="normal"
          key={flagProps.id}
          id={flagProps.id}
          icon={this.getTypeIcon(flagProps.type)}
          {...flagProps}
        />
      );
    });

    return <FlagGroup onDismissed={this.dismissFlag}>{flags}</FlagGroup>;
  }

  private dismissFlag = (id: string) => {
    this.props.flagStore.removeFlag(id);
  };

  private getTypeIcon = (type: FlagType) => {
    switch (type) {
      case FlagType.ERROR:
        return <ErrorIcon label="" primaryColor={colors.R300} />;

      case FlagType.WARNING:
        return <WarningIcon label="" primaryColor={colors.Y300} />;

      default:
        return <SuccessIcon label="" primaryColor={colors.G300} />;
    }
  };
}

export default inject(({ flagStore }: Store) => ({ flagStore }))(Flags);
